"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIForm;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _DomEvents = require("../utils/DomEvents");

function UIForm(props) {
  var action = props.action,
      className = props.className,
      _onKeyDown = props.onKeyDown,
      onSubmit = props.onSubmit,
      rest = (0, _objectWithoutProperties2.default)(props, ["action", "className", "onKeyDown", "onSubmit"]);
  return (
    /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
    _react.default.createElement("form", (0, _extends2.default)({}, rest, {
      className: (0, _classnames.default)('private-form', className),
      action: action,
      onKeyDown: function onKeyDown(evt) {
        // Submit on Cmd+Enter or Ctrl+Enter (avoiding double-submit from an <input>: #4578)
        var inputFocused = document.activeElement instanceof HTMLInputElement;

        if (evt.key === 'Enter') {
          if (evt.metaKey || evt.ctrlKey && !inputFocused) {
            if (onSubmit) onSubmit((0, _SyntheticEvent.default)());
          }
        }

        if (_onKeyDown) _onKeyDown(evt);
      },
      onSubmit: !action && !onSubmit ? _DomEvents.preventDefaultHandler : onSubmit
    }))
    /* eslint-enable jsx-a11y/no-noninteractive-element-interactions */

  );
}

UIForm.propTypes = {
  action: _propTypes.default.string,
  children: _propTypes.default.node.isRequired,
  onSubmit: _propTypes.default.func
};
UIForm.displayName = 'UIForm';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/form/UIForm.js
// module id = 604
// module chunks = 209 210 211 212